import React, { useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';

const ArchetypeBadge = ({ archetype, onClick, className = '' }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const getArchetypeColor = (nivel) => {
        switch (nivel) {
            case 'TRADICIONALES RESISTENTES':
                return 'bg-red-100 text-red-800 border-red-200';
            case 'EN TRANSICIÓN':
                return 'bg-teal-100 text-teal-800 border-teal-200';
            case 'FUNCIONALES CON POTENCIAL':
                return 'bg-blue-100 text-blue-800 border-blue-200';
            case 'EARLY ADOPTERS Y ESCALADORES':
                return 'bg-green-100 text-green-800 border-green-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const getArchetypeIcon = (nivel) => {
        switch (nivel) {
            case 'TRADICIONALES RESISTENTES':
                return '🏪';
            case 'EN TRANSICIÓN':
                return '🔄';
            case 'FUNCIONALES CON POTENCIAL':
                return '📈';
            case 'EARLY ADOPTERS Y ESCALADORES':
                return '🚀';
            default:
                return '💼';
        }
    };

    if (!archetype) {
        return null;
    }

    return (
        <div className={`relative inline-block ${className}`}>
            <button
                onClick={onClick}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border transition-all duration-200 hover:scale-105 ${getArchetypeColor(archetype.nivel)}`}
            >
                <span className="mr-1">{getArchetypeIcon(archetype.nivel)}</span>
                <span className="truncate max-w-24">{archetype.nombrePerfil}</span>
                <FaInfoCircle className="ml-1 text-xs opacity-60" />
            </button>

            {/* Tooltip */}
            {showTooltip && (
                <div className="absolute z-50 mt-2 w-64 bg-white border border-gray-200 rounded-lg shadow-lg p-3">
                    <div className="flex items-start">
                        <span className="text-lg mr-2">{getArchetypeIcon(archetype.nivel)}</span>
                        <div className="flex-1">
                            <h4 className="font-semibold text-gray-800 text-sm mb-1">
                                {archetype.nombrePerfil}
                            </h4>
                            <p className="text-xs text-gray-600 mb-2">
                                {archetype.nivel}
                            </p>
                            <p className="text-xs text-gray-700 leading-relaxed">
                                {archetype.descripcionPerfil}
                            </p>
                            <div className="mt-2 pt-2 border-t border-gray-100">
                                <span className="text-xs text-gray-500">
                                    Puntuación: {archetype.puntuacionTotal}/48
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Arrow */}
                    <div className="absolute top-0 left-4 transform -translate-y-1">
                        <div className="w-2 h-2 bg-white border-l border-t border-gray-200 transform rotate-45"></div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ArchetypeBadge; 